import {combineReducers, createStore} from 'redux'

export default ()=>{
  const rootReducer = combineReducers({
    moodboard: require('./CarousselMoodboardRedux').reducer
  })
  return createStore(rootReducer)
}


// WEBPACK FOOTER //
// ./resources/assets/frontend/js/redux/index.js